export enum CreationMode {
  Create = 'create',
  Parent = 'parent', 
  Link = 'link'
}
